import styled, { css } from 'styled-components';
import theme from 'src/theme';

export const Wrapper = styled.div`
    height: 100%;
`;

export const HeadingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${theme.legacyColors.headingColor};
    background: ${theme.legacyColors.headingPanelBgColor};
    border-bottom: 2px solid #00447e;
    height: 60px;
`;

export const HeadingLeftWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex: 0 0 80%;
    justify-content: left;
    align-items: center;
`;

export const HeadingRightWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex: 0 0 20%;
    justify-content: right;
    align-items: flex-end;
`;

export const EventTypeIconWrapper = styled.div`
    position: left;
    display: flex;
    align-items: center;
    margin-left: 15px;
    margin-right: 2px;
    line-height: 1;
    width: 1.15rem;
    height: 18px;
    svg {
        fill: ${theme.legacyColors.headingColor};
        width: 100%;
    }
`;

export const EventNameWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        padding: 0;
        margin: 0 10px;
        p {
            margin: 0;
            font-size: 0.7rem;
        }
    }
`;

export const PrinterButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 9px;
`;

export const EventContentWrapper = styled.div`
    height: calc(100% - 50px);
    overflow-y: auto;
`;

export const EventInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.8rem;
    margin: 30px 0 0;
    padding: 0 5px;
    input[type='text'] {
        font: inherit;
        border: 1px solid #ddd;
        width: 100%;
        transition: all 0.1s linear, padding 0s, border 0s;
        display: inline-block;
        padding: 0 1rem;
        line-height: 2rem;
        height: 2rem;
        color: rgba(42, 48, 57, 1);
        font-size: 0.9rem;
        color: #222;
        border-radius: 4px;
        font-size: 0.9rem;
    }

    input.time-input {
        padding: 0 2px;
        text-align: center;
        line-height: inherit;
        height: auto;
        width: 45px;
    }

    textarea {
        border: 1px solid #ddd;
        font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
            'Helvetica Neue', sans-serif;
        font-size: 0.9rem;
        border-radius: 0 4px 4px 0;
        height: 30px;
        width: 100%;
        outline: none;
        padding: 0.26rem;

        &::placeholder {
            color: #222;
            font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
                'Helvetica Neue', sans-serif;
            font-size: 0.9rem;
        }
    }
`;

export const InputWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    margin-bottom: 5px;
`;

export const InputHeadingWrapper = styled.div`
    display: flex;
    flex: 0 0 35%;
    max-width: 35%;
    justify-content: flex-start;
    align-items: center;
    font-size: 0.9rem;
    font-weight: 500;
    margin: 0 10px 0 0;
`;

export const InputFieldWrapper = styled.div`
    display: flex;
    flex: 0 0 60%;
    max-width: 60%;
    justify-content: right;
    justify-content: flex-end;
`;

export interface IInputProps {
    isValid?: boolean;
    isNotValid?: boolean;
}

export const ValidationWrapper = styled.div<IInputProps>`
    display: flex;
    justify-content: right;
    font-size: 0.8rem;
    width: 100%;
    height: max-content;

    .select-input {
        width: 100%;
    }

    ${({ isNotValid }) =>
        isNotValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isNotValid }) =>
        !isNotValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
  
  ${({ isValid }) =>
        !isValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}  

  ${({ isValid }) =>
        isValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
`;

export const ErrorMessage = styled.div`
    color: ${theme.legacyColors.error};
    font-size: 0.9rem;
    font-weight: 500;
    text-align: left;
    margin-top: 5px;
    margin-bottom: 10px;
`;

export const InfoMessage = styled.div`
    color: ${theme.legacyColors.error};
    font-size: 0.9rem;
    font-weight: 500;
    text-align: left;
    margin-top: 5px;
    margin-bottom: 10px;
`;

export const ShoresideInstructionOuterGroup = styled.div`
    display: flex;
    margin: 10px;
    border: 1px solid #ccc;
`;

export const ShoresideInstructionGroupFile = styled.div<IShoresideInstructionProps>`
    display: flex;
    margin: 10px;

    font-size: 0.9rem;
    font-weight: 500;
    text-align: left;

    .eventTypeId-${(props) => props.eventTypeId} {
        display: inline-block !important;
    }
`;

export const ShoresideInstructionGroup = styled.div`
    display: flex;
    margin: 10px;
    font-size: 0.9rem;
    font-weight: 400;
    text-align: left;
`;

export const ShoresideInstructionOuter = styled.div`
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
`;

export const ShoresideInstruction = styled.div`
    display: flex;
    margin: 10px;
    font-size: 0.9rem;
    font-weight: 400;
    text-align: left;
`;

export interface IShoresideInstructionProps {
    eventTypeId?: number;
}

export const ShoresideInstructionFile = styled.div<IShoresideInstructionProps>`
    display: flex;
    margin: 10px;
    font-size: 0.9rem;
    font-weight: 500;
    text-align: left;

    .eventTypeId-${(props) => props.eventTypeId} {
        display: inline-block !important;
    }
`;

export const ConfirmDeleteEvent = styled.div`
  color: #da4848;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: right;
  h4{
    margin: -5px 5px 10px 0;k
    font-size: 0.9rem;
    font-weight: 500;
  } 
`;

export const DeleteEventWrapper = styled.div`
  color: ${theme.legacyColors.error};
  font-size: 0.8rem;
  font-weight: 500;
  text-align: right;
  h4{
    margin: -5px 0 10px 0;k
    font-size: 0.9rem;
    font-weight: 500;
  } 
`;

export const EventGroupHeadingWrapper = styled.div`
    display: flex;
    margin-bottom: 10px;
`;

export const EventGroupInputWrapperOuter = styled.div`
    display: flex;
    margin: 10px;
    border: 1px solid #ccc;
    background: #eee;
`;

export const EventGroupInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.8rem;
    margin: 10px;
    width: 100%;
`;

export const CancelSaveRightContentWrapper = styled.div`
    font-size: 0.8rem;
    font-weight: 400;
    color: #04265a;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 2px;
    position: relative;
`;

export interface IButtonProps {
    isSelected?: boolean;
    onClick?: () => void;
}

export const StyledButton = styled.button<IButtonProps>`
    font-size: 1em;
    margin: 3px;
    padding: 0.5em 1.5em;
    border-radius: 4px;
    outline: none;
    cursor: pointer;

    &.delete-btn {
        position: absolute;
        top: 0;
        left: 0;
    }

    &.primary-btn {
        background: #f4f4f4;
    }

    @media only screen and (max-width: 1280px) {
        font-size: 0.8rem;
        padding: 0.4em 0.8em;
    }

    ${({ isSelected }) =>
        !isSelected &&
        css`
            opacity: 0.25;
        `}

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.35;
        `}
`;
